import { ChevronDown, ChevronUp, LucideMenu } from "lucide-react";
import logo from "../assets/images/Logo.png";
import { MenuItems } from "../config/menuConfig";
import { registration_menu } from "../config/menuConfig";
import {
  Dispatch,
  SetStateAction,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { checkPath, cn, toastMessage, toBoolean } from "../utils/utils";
import { DictionaryType, enumSectionType, MenuItem } from "../types";
import { Link, useLocation, useNavigate } from "react-router-dom";
import usePreNavigation from "../hooks/usePreNavigation";
import { log } from "node:console";
import { FORM_ROUTES, MOBILE_VIEW_ENDPOINT } from "../constants";
import modelLogo from "../assets/icons/mocionLogo.svg";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "react-tooltip";
import Modal from "../components/global/Modal";
import close from "../assets/icons/DELETE __ DARK.svg";
import { useGetDictionary } from "../hooks/useGetDictionary";
import Button from "../components/global/Button";
import { setFormIsDirty } from "../lib/redux/slices/formSlice";
import axios from "axios";
import { toast } from "react-toastify";
import { baseURL } from "../Api/apis";
import micon from "../assets/icons/MIcon.svg";
import { useViewport } from "../hooks/useViewport";
import { closeSideBar, openSideBar, resetFilter } from "../lib/redux/slices/controlSlice";
import useOutsideClick from "../hooks/useOutsideClick";
import { UserSliceType } from "../lib/redux/slices/userSlice";

type Props = {};
const SubMenu = ({
  item,
  openSections,
  currentPage,
  setCurrentPage,
  setOpenModel,
  CustomNavigate,
  onSuccess,
  onCancel,
  smallSidebar,
}: {
  item: MenuItem;
  openSections: string[];
  currentPage: string;
  setCurrentPage: any;
  setOpenModel: any;
  CustomNavigate: any;
  onSuccess: any;
  onCancel: any;
  smallSidebar: boolean;
}) => {
  const divRef = useRef<HTMLDivElement>(null);
  const premission = useSelector(
    (state: any) => state?.user?.currentPremission
  );
  // function to confirm navigation depending on the current path and the list of forms paths
  // you must add this fuction to any link or button that navigates to another page
  // with preventDefault() to avoid the default behavior of the browser
  const { sidebar }: DictionaryType = useGetDictionary();
  const [divHeight, setDivHeight] = useState(0);
  const [subMenu, setSubMenu] = useState<any>();
  const lang = useSelector((state: any) => state?.user?.lang);
  const user_stage = useSelector((state: any) => state?.user?.stage);
  const status = useSelector((state: any) => state?.user?.status);
  const stage = useSelector((state: any) => state.user.stage);
  const [showTooltip, setShowTooltip] = useState(true);
  useEffect(() => {
    if (divRef.current) {
      setDivHeight(divRef.current.clientHeight);
    }
  }, [divRef.current, user_stage]);

  useLayoutEffect(() => {
    const handleSubMenu = () => {
      const subMenu = item?.subMenu ?? [];

      switch (user_stage) {
        case "organization":
          return subMenu.slice(0, 1); // Get the first item
        case "clubs":
          return subMenu.slice(0, 2); // Get the first two items
        case "courts":
          return subMenu.slice(0, 3); // Get the first three items
        case "pricing":
          return subMenu.slice(0, 4); // Get the first four items
        case "subscription":
          return subMenu.slice(0, 4); // Get the first four items
        default:
          return subMenu; // Return the entire array
      }
    };
    setSubMenu(handleSubMenu());
  }, [user_stage]);

  useEffect(() => {
    // Whenever the user_stage changes, show the tooltip
    setShowTooltip(true);
  }, [user_stage]);

  const handleCloseTooltip = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    setShowTooltip(!setShowTooltip); // Close the tooltip
  };
  const formIsDirty = useSelector((state: any) => state.form.isDirty);

  return (
    <div
      ref={divRef}
      className={cn(
        "sub-menu  flex flex-col gap-2  custom-transition overflow-hidden px-1",
        openSections.includes(item.title)
          ? `${
              user_stage == "approved" ? `h-[${divHeight}px]` : "h-[190px]"
            }  flex py-3 opacity-100`
          : "h-0 opacity-0"
      )}
    >
      <Tooltip
        id={user_stage == "subscription" ? "clubs" : user_stage}
        isOpen={showTooltip}
        clickable
        style={{
          backgroundColor: "#CBDB2A",
          color: "#1e1850",
          top: "0px",
          paddingTop: 4,
          paddingBottom: 5,
          paddingRight: 10,
          paddingLeft: 10,
          boxShadow: "2px 3px 5px  rgb(0 0 0 / 0.2)",
          border: "10px",
          fontWeight: "bold",
          fontSize: "12px",
          zIndex: 20,
        }}
        place="bottom-start"
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="flex flex-row gap-4"
        >
          <p>
            {user_stage == "courts"
              ? "Click Here to add court to your club"
              : user_stage == "pricing"
              ? "Click here to add your pricing list"
              : user_stage == "subscription"
              ? "Now you can subscribe in package for your club"
              : ""}
          </p>
          <button
            onClick={handleCloseTooltip}
            style={{ fontSize: "12px", cursor: "pointer" }}
            className="text-primary dark:text-white"
          >
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.22749 9.83555L0.164062 8.77213L3.93716 4.99902L0.164062 1.25092L1.22749 0.1875L5.00059 3.9606L8.74869 0.1875L9.81211 1.25092L6.03901 4.99902L9.81211 8.77213L8.74869 9.83555L5.00059 6.06245L1.22749 9.83555Z"
                fill="#252525"
              />
            </svg>
          </button>
        </div>
      </Tooltip>

      {subMenu?.map((subItem: any, index: number) => {
        // console.log(subItem);
        // console.log(subMenu);
        // console.log(premission);

        if (subItem.tag !== "none") {
          //@ts-ignore
          const isAllowed = premission?.find(
            //@ts-ignore
            (role) => role?.section === subItem.tag
          )?.read;
          //console.log(isAllowed);
          const isActive = status === "Active";
          const isApproved = stage === "approved";
          const OrgRules = premission?.find(
            //@ts-ignore
            (role) => role?.section.toLowerCase() === "organization"
          );

          // if (OrgRules && !OrgRules?.read) {
          //   return;
          // }
          if (!isAllowed) {
            if (subItem.tag === "Organization") {
              if (status === "Active") {
                return;
              }
            } else if (subItem.tag !== "Home") {
              return;
            }
          }
          if (
            status !== "Active" &&
            stage !== "approved" &&
            subItem.tag === "Home" &&
            !isAllowed
          ) {
            return;
          }
        }
        return (
          user_stage && (
            <Link
              key={index}
              to={subItem.href}
              onClick={(e) => {
                e.stopPropagation();
                
                if (
                  user_stage == subItem.href.split("/").pop() ||
                  user_stage == "subscription"
                )
                  setShowTooltip(false);
                else setShowTooltip(true);
                setCurrentPage(subItem.href.split("/")[2]);

                e.preventDefault();
                CustomNavigate(subItem.href);
                if (checkPath(window.location.pathname) && formIsDirty) {
                  setOpenModel(true);
                } else {
                  
                  onSuccess(subItem.href);
                }
              }}
            >
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  
                  if (
                    user_stage == subItem.href.split("/").pop() ||
                    user_stage == "subscription"
                  )
                    setShowTooltip(false);
                  else setShowTooltip(true);
                  const listPath = subItem.href.split("/")
                  if(listPath.length > 2){
                 setCurrentPage(listPath[2].split("?")[0]);
                  }else{
                     setCurrentPage(listPath[1].split("?")[0]);
                  }
                  
                }}
                className={
                  !smallSidebar
                    ? `sub-item hover:bg-[#332F4B] hover:text-primaryYellow  ${
                        lang == "ar" ? "hover:border-r-4" : "hover:border-l-4"
                      } ${
                        window.location.pathname == subItem.href?.split("?")[0]
                          ? `bg-[#CBDB2A] text-primary border-[#CBDB2A] rounded-sm ${
                              lang == "ar" ? "border-r-4" : "border-l-4"
                            } bg-[#332F4B]`
                          : ""
                      } hover:border-[#CBDB2A]  cursor-pointer`
                    : "cursor-default"
                }
              >
                <div
                  //  to={subItem.href}
                  className={`sub-item-link px-4 py-2  ${
                    smallSidebar ? "justify-center" : ""
                  }  flex gap-1 items-center `}
                  onClick={(e) => {
                    e.preventDefault();

                     
                    CustomNavigate(subItem.href);
                    if (checkPath(window.location.pathname) && formIsDirty) {
                      setOpenModel(true);
                    } else {
                    
                      onSuccess(subItem.href);
                    }
                  }}
                >
                  <div
                    className={
                      smallSidebar
                        ? `hover:bg-primaryYellow cursor-pointer  px-3 py-3 transition duration-300 hover:text-primary rounded-lg ${
                            window.location.pathname ==
                            subItem.href?.split("?")[0]
                              ? `bg-primaryYellow text-primary    dark:text-white `
                              : ""
                          } `
                        : ""
                    }
                  >
                    {subItem.Icon && <subItem.Icon />}
                  </div>

                  <p
                    data-tooltip-id={
                      user_stage == subItem.href.split("/").pop() &&
                      user_stage != "organization" &&
                      user_stage != "clubs" &&
                      user_stage != "subscription"
                        ? user_stage
                        : user_stage == "subscription" &&
                          subItem.href.split("/").pop() == "clubs"
                        ? "clubs"
                        : ""
                    }
                  >
                    {/* @ts-ignore */}
                    {!smallSidebar && (sidebar[subItem.title] || subItem.title)}
                  </p>
                </div>
              </div>
            </Link>
          )
        );
      })}
    </div>
  );
};

// Next we make an 'instance' of it
const axiosConfig = axios.create({
  // .. where we make our configurations
  baseURL: baseURL, //http://localhost:8800
  withCredentials: true,
});
// instance.defaults.timeout = 10000;
// Where you would set stuff like your 'Authorization' header, etc ...

// Also add/ configure interceptors && all the other cool stuff

axios.interceptors.request.use(
  (request) => {
    //console.log(request);
    // Edit request config
    return request;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    //console.log(response);
    // Edit response config
    return response;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

function Sidebar({}: Props) {
  const { shared, sidebar }: DictionaryType = useGetDictionary();
  const status = useSelector((state: UserSliceType) => state.user.status);
  const isSideBarVisible = useSelector(
    (state: any) => state?.control?.isOpenSidebar
  );
  const [smallSidebar, setSmallSideBar] = useState(
    toBoolean(sessionStorage.getItem("smallSidebar")) || false
  );
  const [isSmallView, setIsSmallView] = useState(false);
  const [loadingDbUrl, setLoadingDbUrl] = useState(false);
  const premission = useSelector(
    (state: any) => state?.user?.currentPremission
  );
  // const {data,isLoading,isSuccess} = useLoginDBQuery('',{
  //   skip:!loadingDbUrl
  // });
  const [openModel, setOpenModel] = useState(false);
  const { isMobile, isDesktop, isTablet, sizeInfo, isLandscapeOrientation } =
    useViewport();
  const lang = useSelector((state: any) => state?.user?.lang);
  const formIsDirty = useSelector((state: any) => state.form.isDirty);
  const dispatch = useDispatch();
  //@ts-ignore
  const fetchUrl = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await toast.promise(
        axiosConfig
          .get("/db_login", {
            headers: {
              access_token: token,
            },
          })
          .then((res) => {
            //@ts-ignore

            window.open(res.data.url, "_blank");
          }),
        toastMessage()
      );
    } catch (error) {}
  };

  useEffect(() => {
    if (sizeInfo.currentWidth < MOBILE_VIEW_ENDPOINT) {
      dispatch(closeSideBar());
      setIsSmallView(true);
      setSmallSideBar(false);
    } else {
      setIsSmallView(false);
      dispatch(openSideBar());
    }
  }, [sizeInfo.currentWidth]);

  // let erp_url = JSON.parse(localStorage.getItem("generalInfo"))?.erp_url;
  // useEffect(()=>{
  //     if(data && isSuccess){
  //         setLoadingDbUrl(false)
  //         console.log(data);

  //     }
  // },[data,isSuccess])
  // function to confirm navigation depending on the current path and the list of forms paths
  // you must add this fuction to any link or button that navigates to another page
  // with preventDefault() to avoid the default behavior of the browser
  // const handleNavigation = usePreNavigation(async (path) => {

  //   if (FORM_ROUTES.includes(window.location.pathname)) {
  //     setOpenModel(true);
  //     //return window.confirm("Are you sure you want to leave?");
  //   }
  //   return true;
  // },{

  // }).CustomNavigate;
  const { onCancel, onSuccess, CustomNavigate } = usePreNavigation(null, {
    isCustom: true,
    onSuccess: () => {
      console.log("redux test");
      
      //@ts-ignore
      dispatch(resetFilter())
      // reset redux
    },
  });
  const user_stage = useSelector((state: any) => state?.user?.stage);
  //const user_status = useSelector((state: any) => state?.user?.status);
  const { pathname, search } = useLocation();

  const [currentPage, setCurrentPage] = useState(
    pathname.split("/").length >= 3
      ? pathname.split("/")[2]
      : pathname.split("/")[1]
  );
  // console.log(pathname);
  // console.log(currentPage);

  const [openSections, setOpenSections] = useState<string[]>(
    smallSidebar
      ? ["Organization Settings", "Events", "Coaching", "General"]
      : []
  );

  const handleOpenSection = (sectionName: string, event: React.MouseEvent) => {
    event.stopPropagation();
    setOpenSections((prev) =>
      prev.includes(sectionName)
        ? prev.filter((item) => item !== sectionName)
        : user_stage != "approved" ? ["Organization Settings", sectionName] : [sectionName]
    );
  };

  const sidebarMenu = user_stage != "approved" ? registration_menu : MenuItems;
  const sidebarRef = useRef(null);
  const handleClose = () => {
    dispatch(closeSideBar());
  };
  useOutsideClick(sidebarRef, handleClose, "mousedown", !isSmallView);
  // useEffect(() => {
  //   setOpenSections((prev) => {
  //     if (!user_stage || user_stage !== "approved"){
  //           return ["Organization Settings", ...prev];
  //     };
  //     else{

  //     }
      
  //   });
  // }, [pathname]);
  useEffect(() => {
     if(user_stage && user_stage !== "approved"){
       setOpenSections((prev) => {
         return ["Organization Settings", ...prev];
       });
     }else{
      
      sidebarMenu.filter((item)=> item.isGroupItem).forEach((parent)=>{
          parent.subMenu?.forEach((subItem)=>{
            console.log(subItem.href);
            console.log(window.location.pathname);
            
            
            if(window.location.pathname === subItem.href.split("?")[0])
         {
          console.log(parent);
          
           setOpenSections((prev) =>
      prev.includes(parent.title)
        ? prev
        : [...prev, parent.title]
    ); 
 return
  }

          })


      })
       
     }
  },[user_stage])
  return (
    <div
      ref={sidebarRef}
      className={cn(
        `   rounded-lg   bg-primary text-white dark:text-primary dark:bg-white  flex flex-col h-dvh   items-center transition-all  `,
        isSideBarVisible ? (smallSidebar ? "w-[100px]" : "w-[283px]") : "w-0",
        isSmallView && "absolute z-[1000] overflow-hidden"
      )}
    >
      {sizeInfo.currentWidth < MOBILE_VIEW_ENDPOINT && (
        <div
          className="absolute right-[10px] top-[10px] cursor-pointer "
          onClick={() => {
            dispatch(closeSideBar());
          }}
        >
          <img loading="lazy" src={close} alt="Close" />
        </div>
      )}
      <div className=" relative w-full  ">
        {!isSmallView && (
          <div
            onClick={() => {
              sessionStorage.setItem("smallSidebar", `${!smallSidebar}`);
              setOpenSections([
                "Organization Settings",
                "Events",
                "Coaching",
                "General",
              ]);
              setSmallSideBar(!smallSidebar);
            }}
            className="bg-white  rounded-lg absolute -right-5 top-12 shadow-xl  py-1 px-1  hover:cursor-pointer z-10"
          >
            <LucideMenu className="text-primary w-8 h-8" />
          </div>
        )}
      </div>
      <div
        className={`logo grid place-content-center ${
          smallSidebar ? "py-[20px]" : "py-[30px]"
        }  `}
      >
        <img
          loading="lazy"
          src={smallSidebar ? micon : logo}
          width={smallSidebar ? "40px" : "140px"}
          alt=""
        />
      </div>

      <div className="links-content w-full overflow-y-auto customScroll-sidebar ">
        {sidebarMenu.map((item, index) => {
          if (!item.isGroupItem && item.tag !== "none") {
            //@ts-ignore
            const isAllowed = premission?.find(
              //@ts-ignore
              (role) => role?.section === item.tag
            )?.read;
            //console.log(isAllowed);
            const isActive = status === "Active";
            const isApproved = user_stage === "approved";
            const OrgRules = premission?.find(
              //@ts-ignore
              (role) => role?.section.toLowerCase() === "organization"
            );

            // if (OrgRules && !OrgRules?.read) {
            //   return;
            // }
            if (!isAllowed) {
              if (item.tag === "Organization") {
                if (status === "Active") {
                  return;
                }
              } else if (item.tag !== "Home") {
                return;
              }
            }
            if (
              status !== "Active" &&
              user_stage !== "approved" &&
              item.tag === "Home" &&
              !isAllowed
            ) {
              return;
            }
          }
          if (item.isGroupItem) {
            //@ts-ignore
            const isAllowed = item.tag.some(
              (tag: enumSectionType) =>
                premission?.find((role: any) => role?.section === tag)?.read
            );
            if (!isAllowed) {
              return;
            }
            return (
              <div
                key={index}
                className="group-item flex flex-col w-full  cursor-pointer "
                onClick={(e) => {
                  !smallSidebar && handleOpenSection(item.title, e);
                }}
              >
                {/* hover:text-primaryYellow hover:border-[#CBDB2A] hover:bg-[#332F4B]  */}
                {/* ${
                      lang == "ar" ? "hover:border-r-4" : "hover:border-l-4"
                    } */}
                <div
                  className={`flex w-full ${
                    smallSidebar ? "justify-center " : "justify-between"
                  } items-center py-3 px-4 ${
                    !smallSidebar
                      ? `hover:text-primaryYellow hover:border-[#CBDB2A] hover:bg-[#332F4B] ${
                          lang == "ar" ? "hover:border-r-4" : "hover:border-l-4"
                        }`
                      : ""
                  }  `}
                >
                  <h3
                    className={`font-bold ${
                      smallSidebar ? "text-center text-sm" : "text-lg"
                    } `}
                  >
                    {/* @ts-ignore */}
                    {sidebar[item.title] || item.title}
                  </h3>
                  {openSections.includes(item.title)
                    ? !smallSidebar && <ChevronUp className="w-6 h-6" />
                    : !smallSidebar && <ChevronDown className="w-6 h-6" />}
                </div>
                <SubMenu
                  smallSidebar={smallSidebar}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  item={item}
                  setOpenModel={setOpenModel}
                  CustomNavigate={CustomNavigate}
                  onSuccess={onSuccess}
                  onCancel={onCancel}
                  openSections={openSections}
                />
              </div>
            );
          } else {
            return (
              <div className="px-1">
                <div
                className={`item flex w-full px-1 ${
                  !smallSidebar
                    ? ` ${
                        currentPage == item.href.split("/")[1].split("?")[0]
                          ? `bg-[#CBDB2A] text-primary border-[#CBDB2A] rounded-sm `
                          : ""
                      }  hover:bg-[#332F4B]  hover:text-primaryYellow ${
                        lang == "ar" ? "hover:border-r-4" : "hover:border-l-4"
                      } hover:border-[#CBDB2A] cursor-pointer`
                    : " cursor-default"
                } `}
                onClick={(e) => {
                  setCurrentPage(item.href.split("/")[1].split("?")[0]);
                }}
              >
                <Link
                  to={item.href}
                  className={`item-link w-full flex gap-2 items-center px-4  ${
                    smallSidebar ? "justify-center cursor-default" : ""
                  } py-3 `}
                  onClick={(e) => {
                    e.preventDefault();
                    
                    
                    CustomNavigate(item.href);
                    if (checkPath(window.location.pathname) && formIsDirty) {
                      setOpenModel(true);
                    } else {
                      
                      //@ts-ignore
                      dispatch(resetFilter())
                      onSuccess(item.href);
                    }
                  }}
                >
                  <div
                    className={`${
                      !smallSidebar
                        ? ""
                        : `hover:bg-primaryYellow cursor-pointer  px-3 py-3 transition duration-300 hover:text-primary rounded-lg ${
                            currentPage == item.href.split("/")[1].split("?")[0]
                              ? `bg-primaryYellow text-primary    dark:text-white `
                              : ""
                          }`
                    } `}
                  >
                    {item.Icon && <item.Icon />}
                  </div>

                  {/* @ts-ignore */}
                  {!smallSidebar && (sidebar[item.title] || item.title)}
                </Link>
              </div>
              </div>
              
            );
          }
        })}

        {user_stage == "approved" && (
          <span
            className="item-link w-full flex gap-2 items-center text-lg  py-3 "
            onClick={(e) => {
              fetchUrl();
            }}
          >
            {premission?.find((role: any) => role?.section === "Erp")?.read && (
              <div
                className={
                  !smallSidebar
                    ? `item flex w-full   hover:bg-[#332F4B] hover:text-primaryYellow py-3 px-4 ${
                        lang == "ar" ? "hover:border-r-4" : "hover:border-l-4"
                      } hover:border-[#CBDB2A] cursor-pointer`
                    : " flex justify-center w-full"
                }
              >
                <p
                  className={`${
                    smallSidebar
                      ? `hover:bg-primaryYellow cursor-pointer  px-3 py-3 transition duration-300 hover:text-primary rounded-lg`
                      : ""
                  }`}
                >
                  {" "}
                  ERP
                </p>
              </div>
            )}
          </span>
        )}
      </div>

      <div className=" fixed z-50">
        <Modal modalMaxWidth="max-w-lg" isOpen={openModel}>
          <div className="  flex flex-col gap-8 px-12 py-5 ">
            <div
              className={cn(
                "flex flex-col justify-center items-center gap-4 text-center ",
                isLandscapeOrientation() && isMobile && "gap-1"
              )}
            >
              <img
                loading="lazy"
                width={isLandscapeOrientation() && isMobile ? 70 : 200}
                height={200}
                src={modelLogo}
                alt="mocion-logo"
              />
              <div>
                <h2>{shared.attention}!!</h2>
                <p className="text-lg font-normal  text-[#1E1850] break-words leading-relaxed whitespace-pre-wrap  ">
                  {shared.discard_changes}
                </p>
              </div>
              <div className="mt-6 flex flex-col items-center justify-center gap-6  w-full">
                <Button
                  customeStyle=" bg-primary text-white  w-full rounded-full  text-lg py-4  "
                  text={shared.yes}
                  width="max-w-[400px] w-full"
                  onClick={() => {
                    onSuccess();
                    setOpenModel(false);
                  }}
                />
                <Button
                  customeStyle="bg-white text-primary dark:text-white   w-full rounded-full text-lg py-4 "
                  text={shared.no}
                  width="max-w-[400px] w-full"
                  onClick={() => {
                    onCancel();
                    setOpenModel(false);
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default Sidebar;
